import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import Checkbox from '@mui/material/Checkbox';
import '../../../style/sort.css';
import { Height } from '@mui/icons-material';
import { width } from '@mui/system';

const ListaHorasExtras = () => {
  const { user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [horasExtras, setHorasExtras] = useState([]);
  const [horasExtrasOriginal, setHorasExtrasOriginal] = useState([]); // Para guardar los datos originales
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState('');
  const [aprobaciones, setAprobaciones] = useState([]);
  const [observaciones, setObservaciones] = useState([]);
  const [filtroCodigo, setFiltroCodigo] = useState('');
  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroUnidad, setFiltroUnidad] = useState('');
  const [selecciones, setSelecciones] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending', // 'ascending' o 'descending'
  });

  const [filtroPendienteN2, setFiltroPendienteN2] = useState(false);
  const [filtroNoAplicados, setFiltroNoAplicados] = useState(false);
  const [mapaSelecciones, setMapaSelecciones] = useState(new Map());


  // Generar un ID único para cada registro
  const generarId = (horaExtra) => {
    return `${horaExtra.che_codigo_alternativo}-${horaExtra.che_fechaini}-${horaExtra.che_fechafin}`;
  };
  // const [selecciones, setSelecciones] = useState({});
  // Inicializar el arreglo de aprobaciones cuando se cargan las horas extras
  useEffect(() => {
    if (horasExtras.length > 0) {
      setAprobaciones(new Array(horasExtras.length).fill(""));
      setObservaciones(new Array(horasExtras.length).fill(""));
    }
    console.log(user)
  }, [horasExtras]);

  useEffect(() => {
    if (horasExtrasOriginal.length > 0) {
      setSelecciones(new Array(horasExtrasOriginal.length).fill(false));
    }
  }, [horasExtrasOriginal]);

  // Función para aplicar los filtros
  useEffect(() => {
    if (horasExtrasOriginal.length > 0) {
      let datosFiltrados = [...horasExtrasOriginal];

      // Aplicar filtros básicos
      if (filtroCodigo) {
        datosFiltrados = datosFiltrados.filter(item =>
          item.che_codigo_alternativo.toLowerCase().includes(filtroCodigo.toLowerCase())
        );
      }

      if (filtroNombre) {
        datosFiltrados = datosFiltrados.filter(item =>
          item.che_nombre.toLowerCase().includes(filtroNombre.toLowerCase())
        );
      }

      if (filtroUnidad) {
        datosFiltrados = datosFiltrados.filter(item =>
          item.uni_descripcion.toLowerCase().includes(filtroUnidad.toLowerCase())
        );
      }

      // Aplicar filtro de pendientes en N2
      if (filtroPendienteN2) {
        datosFiltrados = datosFiltrados.filter(item =>
          !item.AutN2.includes("AUTORIZADO") && !item.AutN2.includes("RECHAZADO")
        );
      }

      // Aplicar filtro de no aplicados
      if (filtroNoAplicados) {
        datosFiltrados = datosFiltrados.filter(item =>
          item.che_codplanilla === "No aplicado"
        );
      }

      setHorasExtras(datosFiltrados);
    }

    if (horasExtras.length > 0) {
      setSelecciones(new Array(horasExtras.length).fill(false));
      setAprobaciones(new Array(horasExtras.length).fill(""));
      setObservaciones(new Array(horasExtras.length).fill(""));
    }

  }, [filtroCodigo, filtroNombre, filtroUnidad, horasExtrasOriginal, filtroPendienteN2, filtroNoAplicados]);



  // Función para manejar cambios en la selección de aprobación/denegación
  const handleAprobacionChange = (index, value) => {
    const nuevasAprobaciones = [...aprobaciones];
    nuevasAprobaciones[index] = value;
    setAprobaciones(nuevasAprobaciones);
  };

  // Función para manejar cambios en las observaciones
  const handleObservacionChange = (index, value) => {
    const nuevasObservaciones = [...observaciones];
    nuevasObservaciones[index] = value;
    setObservaciones(nuevasObservaciones);
  };

  // Función para obtener las horas extras
  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setHorasExtras([]);
    setHorasExtrasOriginal([]);

    if (!fechaSeleccionada) {
      setError('Por favor, selecciona una fecha.');
      setLoading(false);
      return;
    }

    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ObtenerListaHorasExtrasGeneradas',
        Datos_Recibidos: JSON.stringify({ FechaIni: fechaFormateada, FechaFin: fechaFormateada2, CodUsuario: user.usuario }),
      },
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    try {
      const response = await fetch(fetchDataUrl);
      const data = await response.json();
      console.log('Respuesta de la API:', data);

      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);
        console.log('Datos Generados (JSON):', datosGenerados);

        if (datosGenerados.HORAS_EXTRAS) {
          setHorasExtras(datosGenerados.HORAS_EXTRAS);
          setHorasExtrasOriginal(datosGenerados.HORAS_EXTRAS); // Guardar los datos originales
          console.log(datosGenerados.HORAS_EXTRAS);
        } else {
          setError('No se encontraron horas extras en la respuesta.');
        }
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  // Función para enviar las aprobaciones al API
  const enviarAprobaciones = async () => {
    setLoading(true);
    setError(null);

    const userSend = user.id_usuario.toString();

    const formatDate = (date) => {
      if (typeof date === 'string' && date.includes('-')) {
        return date.replace(/-/g, '');
      }
      return date;
    };

    const hayErrores = aprobaciones.some((tipo, index) => {
      return tipo === "D" && (!observaciones[index] || observaciones[index].trim() === "");
    });

    if (hayErrores) {
      alert("Error: Debes ingresar observaciones para todos los registros que tienen Tipo 'D'");
      setLoading(false);
      return; // Detiene el proceso
    }
    console.log('12222222')

    const datosParaEnviar = horasExtras
      .map((horaExtra, index) => ({
        ...horaExtra,
        Tipo: aprobaciones[index],
        Observaciones: aprobaciones[index] === "D" ? observaciones[index] : "",
      }))
      .filter((horaExtra) => horaExtra.Tipo === "A" || horaExtra.Tipo === "D")
      .map((horaExtra) => ({
        CodEmp: horaExtra.che_codigo_alternativo,
        FechaIni: formatDate(horaExtra.che_fechaini),
        FechaFin: formatDate(horaExtra.che_fechafin),
        CodUsuarioAut: userSend,
        Tipo: horaExtra.Tipo,
        Observaciones: horaExtra.Observaciones,
        Proceso: "A",
      }));

    const datosAPI = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'ProcesoAutorizacionMasivo',
        Datos_Recibidos: JSON.stringify(datosParaEnviar),
        Datos_Generados: "",
      },
    };

    const fetchDataUrl = 'https://appcorp.parma.com.gt/API/ReceptorDatos';

    try {
      const response = await fetch(fetchDataUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosAPI),
      });

      const data = await response.json();
      console.log('Respuesta de la API:', data);

      if (data.datos_Generados === '') {
        alert('Aprobaciones enviadas correctamente');
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  const sortedHorasExtras = React.useMemo(() => {
    if (!sortConfig.key) return horasExtras;

    return [...horasExtras].sort((a, b) => {
      // Manejo especial para fechas
      if (sortConfig.key.includes('fecha')) {
        const dateA = new Date(a[sortConfig.key]);
        const dateB = new Date(b[sortConfig.key]);
        if (dateA < dateB) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (dateA > dateB) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }

      // Manejo para números
      if (['HESD', 'HESM', 'HEDD', 'HEDM'].includes(sortConfig.key)) {
        return sortConfig.direction === 'ascending'
          ? a[sortConfig.key] - b[sortConfig.key]
          : b[sortConfig.key] - a[sortConfig.key];
      }

      // Manejo para texto (default)
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }, [horasExtras, sortConfig]);

  // Manejar cambios en la selección individual
  const handleSeleccionChange = (horaExtra) => {
    const id = generarId(horaExtra);
    setSelecciones(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Manejar selección/deselección masiva
  const handleSeleccionMasiva = () => {
    const allSelected = horasExtras.every(horaExtra => selecciones[generarId(horaExtra)]);

    const nuevasSelecciones = { ...selecciones };
    horasExtras.forEach(horaExtra => {
      const id = generarId(horaExtra);
      nuevasSelecciones[id] = !allSelected;
    });

    setSelecciones(nuevasSelecciones);
  };

  // Verificar si todos los elementos visibles están seleccionados
  const todosSeleccionados = horasExtras.length > 0 &&
    horasExtras.every(horaExtra => selecciones[generarId(horaExtra)]);

  // Verificar si al menos un elemento visible está seleccionado (para el estado indeterminado)
  const algunoSeleccionado = horasExtras.some(horaExtra => selecciones[generarId(horaExtra)]);
  /***********************************************************************/
  /************************************************************************/
  const validarSelecciones = () => {
    const seleccionados = horasExtrasOriginal.filter(horaExtra =>
      selecciones[generarId(horaExtra)]
    );

    if (seleccionados.length === 0) {
      alert('No hay registros seleccionados');
      return;
    }

    for (let i = 0; i < seleccionados.length; i++) {
      if (seleccionados[i].AutN1.includes("AUTORIZADO") && seleccionados[i].AutN2.includes("AUTORIZADO")) {
        console.log(seleccionados[i]);

        // Array to store all JSON objects for this record
        const jsonRecords = [];

        if (seleccionados[i].HESD >= 0) {
          const dtsd = {
            codexp: seleccionados[i].che_codigo_alternativo,
            fechaini: seleccionados[i].che_fechaini,
            fechafin: seleccionados[i].che_fechafin,
            TipoHE: "HESD",
            Cantidad: seleccionados[i].HESD
          };
          jsonRecords.push(dtsd);
          EnviarDatosEvo(dtsd)

        }

        if (seleccionados[i].HESM >= 0) {
          const dtsm = {
            codexp: seleccionados[i].che_codigo_alternativo,
            fechaini: seleccionados[i].che_fechaini,
            fechafin: seleccionados[i].che_fechafin,
            TipoHE: "HESM",  // Fixed from "HESD" to "HESM"
            Cantidad: seleccionados[i].HESM  // Fixed from HESD to HESM
          };
          EnviarDatosEvo(dtsm)

          jsonRecords.push(dtsm);
        }

        if (seleccionados[i].HEDD >= 0) {
          const dtdd = {
            codexp: seleccionados[i].che_codigo_alternativo,
            fechaini: seleccionados[i].che_fechaini,
            fechafin: seleccionados[i].che_fechafin,
            TipoHE: "HEDD",
            Cantidad: seleccionados[i].HEDD
          };
          EnviarDatosEvo(dtdd)

          jsonRecords.push(dtdd);
        }

        if (seleccionados[i].HEDM >= 0) {
          const dtdm = {
            codexp: seleccionados[i].che_codigo_alternativo,
            fechaini: seleccionados[i].che_fechaini,
            fechafin: seleccionados[i].che_fechafin,
            TipoHE: "HEDM",
            Cantidad: seleccionados[i].HEDM
          };
          EnviarDatosEvo(dtdm)
          jsonRecords.push(dtdm);
        }

        // Log all generated JSON records for this iteration
        console.log("Generated JSON records for iteration", i);
        console.log(jsonRecords);

        // Here you would typically send the data to your API
        // For example: await api.sendOvertimeData(jsonRecords);
      }
    }
    enviarDatos();
  };

  const EnviarDatosEvo = async (datosParaEnviar) => {
    const datosAPI = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'CargarHorasExtrasPorEmpleado',
        Datos_Recibidos: JSON.stringify(datosParaEnviar),
        Datos_Generados: "",
      },
    };
    console.log('testt')
    console.log(datosAPI)
    const fetchDataUrl = 'https://appcorp.parma.com.gt/API/ReceptorDatos';

    try {
      const response = await fetch(fetchDataUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosAPI),
      });

      const data = await response.json();
      console.log('Respuesta de la API:', data);

      if (data.datos_Generados) {
        // alert('Aprobaciones enviadas correctamente');
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }

  };
  /**************************************************************************/
  const exportToExcel = () => {
    const datosExportar = horasExtras.map((horaExtra, index) => ({
      'Código Empleado': Number(horaExtra.che_codigo_alternativo),
      'Nombre': horaExtra.che_nombre,
      'Unidad': horaExtra.uni_descripcion,
      'Fecha Inicio': horaExtra.che_fechaini,
      'Fecha Fin': horaExtra.che_fechafin,
      'HESD': horaExtra.HESD,
      'HESM': horaExtra.HESM,
      'HEDD': horaExtra.HEDD,
      'HEDM': horaExtra.HEDM,
      'Total': (horasExtras.HESD + horasExtras.HESM + horasExtras.HEDD + horasExtras.HEDM),
      'Autorización N1': horaExtra.AutN1,
      'Autorización N2': horaExtra.AutN2,
      'Autorización N3': horaExtra.AutN3,
      'Planilla': horaExtra.che_codplanilla,
      'Estado': aprobaciones[index] === "A" ? "Aprobado" : aprobaciones[index] === "D" ? "Denegado" : "Pendiente",
      'Observaciones': observaciones[index] || ""
    }));

    const ws = XLSX.utils.json_to_sheet(datosExportar);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Horas Extras");
    XLSX.writeFile(wb, `HorasExtras_${fechaSeleccionada}_${fechaSeleccionada2}.xlsx`);
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Autorizacion de Horas Extras Generadas</h1>

      {/* Selector de fechas y botón */}
      <div className="row mb-4">
        <div className="col-md-3">
          <label className="form-label">Fecha Inicio:</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fechaSeleccionada}
            onChange={(e) => setFechaSeleccionada(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Fecha Fin:</label>
          <input
            type="date"
            className="form-control form-control-sm"
            value={fechaSeleccionada2}
            onChange={(e) => setFechaSeleccionada2(e.target.value)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-primary btn-sm"
            onClick={enviarDatos}
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Obtener Horas Extras'}
          </button>
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-success btn-sm"
            onClick={enviarAprobaciones}
            disabled={loading || horasExtras.length === 0}
          >
            {loading ? 'Enviando...' : 'Enviar Aprobaciones'}
          </button>
        </div>
      </div>

      {/* Filtros por código y nombre */}
      {horasExtras.length > 0 && (
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Filtrar por Código:</label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ingrese código de empleado"
              value={filtroCodigo}
              onChange={(e) => setFiltroCodigo(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Filtrar por Nombre:</label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ingrese nombre de empleado"
              value={filtroNombre}
              onChange={(e) => setFiltroNombre(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Filtrar por Unidad:</label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ingrese la Unidad"
              value={filtroUnidad}
              onChange={(e) => setFiltroUnidad(e.target.value)}
            />
          </div>
          {user.rol.some(rol => rol.Id_Perfil === 150005 || rol.Id_Perfil === 150010 || rol.Id_Perfil === 150000) && (
            <div className="col-md-3">
              {/* Nuevos filtros como checkboxes */}
              <div className="form-check mt-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="filtroPendienteN2"
                  checked={filtroPendienteN2}
                  onChange={(e) => setFiltroPendienteN2(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="filtroPendienteN2">
                  Mostrar solo pendientes en N2
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="filtroNoAplicados"
                  checked={filtroNoAplicados}
                  onChange={(e) => setFiltroNoAplicados(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="filtroNoAplicados">
                  Mostrar solo no aplicados
                </label>
              </div>
            </div>)}
        </div>
      )}

      {/* Agregar botón para resetear filtros */}
      <div className="col-md-2 d-flex align-items-end">
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => {
            setFiltroCodigo('');
            setFiltroNombre('');
            setFiltroUnidad('');
            setFiltroPendienteN2(false);
            setFiltroNoAplicados(false);
          }}
        >
          Resetear Filtros
        </button>
      </div>

      {/* Mostrar mensaje cuando no hay resultados */}
      {horasExtras.length === 0 && horasExtrasOriginal.length > 0 && (
        <div className="alert alert-warning">
          No se encontraron resultados con los filtros actuales.
        </div>
      )}
      <br />
      {/* Botón de exportar a Excel */}
      <div className="row mb-4">
        <div className="col-md-3 d-flex align-items-end">
        {user.rol.some(rol => rol.Id_Perfil === 1 || rol.Id_Perfil === 150000 || rol.Id_Perfil === 150010) && (
          <button
            className="btn btn-info btn-sm"
            onClick={exportToExcel}
            disabled={horasExtras.length === 0}
          >
            Exportar a Excel
          </button> 
          )}
        </div>
        {user.rol.some(rol => rol.Id_Perfil === 150010 || rol.Id_Perfil === 150000) && (
          <div className="col-md-9 d-flex justify-content-end">
            <button
              className="btn btn-warning btn-sm"
              onClick={validarSelecciones}
              disabled={horasExtras.length === 0}
            >
              {loading ? 'Enviando...' : 'Cargar Empleados Seleccionados a Evolution'}

            </button>
          </div>
        )}
      </div>



      {/* Mostrar errores */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Mostrar los datos de horas extras */}
      {horasExtras.length > 0 && (
        <div  className="table-responsive">
          <table width="1500px" className="table table-bordered table-striped ">
            <thead className="table-dark">
              <tr >
                <th className="th-checkbox"> <Checkbox checked={todosSeleccionados} indeterminate={algunoSeleccionado && !todosSeleccionados} onChange={handleSeleccionMasiva} /></th>
                <th>Código Empleado</th>
                <th width="300px" >Nombre</th>
                <th>Unidad</th>
                <th width="150px" >Fecha Inicio</th>
                <th width="150px" >Fecha Fin</th>
                {user.rol.some(rol => rol.Id_Perfil === 130001 || rol.Id_Perfil === 1 || rol.Id_Perfil === 150000 || rol.Id_Perfil === 150010) && (
                  <React.Fragment>
                    <th>HESD</th>
                    <th>HESM</th>
                    <th>HEDD</th>
                    <th>HEDM</th>
                  </React.Fragment>
                )}
                <th>Total</th>
                <th>Autorizacion N1</th>
                <th>Autorizacion N2</th>
                <th>Planilla</th>
                <th>Acción</th>
                <th>Observaciones</th>


                {/* <th>
                <Checkbox
                    checked={selecciones.every(Boolean) && selecciones.length > 0}
                    indeterminate={
                      selecciones.some(Boolean) &&
                      !selecciones.every(Boolean)
                    }
                    onChange={() => {
                      const allSelected = selecciones.every(Boolean);
                      setSelecciones(new Array(horasExtras.length).fill(!allSelected));
                    }}
                  />

                </th>
                <th>Código Empleado</th>
                <th>Nombre</th>
                <th>Unidad</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>HESD</th>
                <th>HESM</th>
                <th>HEDD</th>
                <th>HEDM</th>
                <th>Autorizacion N1</th>
                <th>Autorizacion N2</th>
                <th>Planilla</th>
                <th>Acción</th>
                <th>Observaciones</th> */}
              </tr>
            </thead>
            <tbody>
              {sortedHorasExtras.map((horaExtra, index) => (
                <tr key={index}>
                  <td>
                    {user.rol.some(rol => rol.Id_Perfil === 150010 || rol.Id_Perfil === 150000) &&
                      horaExtra.che_codplanilla === "No aplicado" && (
                        <Checkbox
                          checked={!!selecciones[generarId(horaExtra)]}
                          onChange={() => handleSeleccionChange(horaExtra)}
                        />
                      )}
                  </td>
                  <td>{horaExtra.che_codigo_alternativo}</td>
                  <td>{horaExtra.che_nombre}</td>
                  <td>{horaExtra.uni_descripcion}</td>
                  <td>{horaExtra.che_fechaini}</td>
                  <td>{horaExtra.che_fechafin}</td>
                  {user.rol.some(rol => rol.Id_Perfil === 130001 || rol.Id_Perfil === 1 || rol.Id_Perfil === 150000 || rol.Id_Perfil === 150010) && (
                    <React.Fragment>
                      <td>{horaExtra.HESD}</td>
                      <td>{horaExtra.HESM}</td>
                      <td>{horaExtra.HEDD}</td>
                      <td>{horaExtra.HEDM}</td>
                    </React.Fragment>
                  )}
                  <td>{horaExtra.HESD + horaExtra.HESM + horaExtra.HEDD + horaExtra.HEDM}</td>

                  <td>{horaExtra.AutN1}</td>
                  <td>{horaExtra.AutN2}</td>
                  <td>{horaExtra.che_codplanilla}</td>
                  <td>
                    {horaExtra.che_codplanilla === "No aplicado" && (
                      <div className="btn-group">
                        <button
                          className={`btn btn-sm ${aprobaciones[index] === "A" ? "btn-success" : "btn-outline-success"
                            }`}
                          onClick={() => handleAprobacionChange(index, "A")}
                        >
                          ✔
                        </button>
                        <button
                          className={`btn btn-sm ${aprobaciones[index] === "D" ? "btn-danger" : "btn-outline-danger"
                            }`}
                          onClick={() => handleAprobacionChange(index, "D")}
                        >
                          ✖
                        </button>
                      </div>
                    )}
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={observaciones[index] || ""}
                      disabled={aprobaciones[index] !== "D"}
                      onChange={(e) => handleObservacionChange(index, e.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListaHorasExtras;